import { render, staticRenderFns } from "./RunningTimeBig.vue?vue&type=template&id=d637a660&scoped=true&lang=pug"
import script from "./RunningTimeBig.vue?vue&type=script&lang=js"
export * from "./RunningTimeBig.vue?vue&type=script&lang=js"
import style0 from "./RunningTimeBig.vue?vue&type=style&index=0&id=d637a660&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d637a660",
  null
  
)

export default component.exports